// Sneaker Brands - Ranked by Annual Revenue
// Difficulty: MEDIUM - Brand recognition varies

export const sneakerBrandsData = [
  { id: 1, name: "Nike", rank: 1, image: "/images/sneakerBrands/nike.png" },
  { id: 2, name: "Adidas", rank: 2, image: "/images/sneakerBrands/adidas.png" },
  { id: 3, name: "Skechers", rank: 3, image: "/images/sneakerBrands/skechers.png" },
  { id: 4, name: "New Balance", rank: 4, image: "/images/sneakerBrands/new_balance.png" },
  { id: 5, name: "ASICS", rank: 5, image: "/images/sneakerBrands/asics.png" },
  { id: 6, name: "Puma", rank: 6, image: "/images/sneakerBrands/puma.png" },
  { id: 7, name: "Under Armour", rank: 7, image: "/images/sneakerBrands/under_armour.png" },
  { id: 8, name: "Vans", rank: 8, image: "/images/sneakerBrands/vans.png" },
  { id: 9, name: "Converse", rank: 9, image: "/images/sneakerBrands/converse.png" },
  { id: 10, name: "Reebok", rank: 10, image: "/images/sneakerBrands/reebok.png" },
  { id: 11, name: "FILA", rank: 11, image: "/images/sneakerBrands/fila.png" },
  { id: 12, name: "HOKA", rank: 12, image: "/images/sneakerBrands/hoka.png" },
  { id: 13, name: "On Running", rank: 13, image: "/images/sneakerBrands/on_running.png" },
  { id: 14, name: "Brooks", rank: 14, image: "/images/sneakerBrands/brooks.png" },
  { id: 15, name: "Jordan Brand", rank: 15, image: "/images/sneakerBrands/jordan.png" },
  { id: 16, name: "Salomon", rank: 16, image: "/images/sneakerBrands/salomon.png" },
  { id: 17, name: "Crocs", rank: 17, image: "/images/sneakerBrands/crocs.png" },
  { id: 18, name: "Birkenstock", rank: 18, image: "/images/sneakerBrands/birkenstock.png" },
  { id: 19, name: "Timberland", rank: 19, image: "/images/sneakerBrands/timberland.png" },
  { id: 20, name: "Dr. Martens", rank: 20, image: "/images/sneakerBrands/dr_martens.png" },
  { id: 21, name: "Allbirds", rank: 21, image: "/images/sneakerBrands/allbirds.png" },
  { id: 22, name: "K-Swiss", rank: 22, image: "/images/sneakerBrands/k_swiss.png" },
  { id: 23, name: "Mizuno", rank: 23, image: "/images/sneakerBrands/mizuno.png" },
  { id: 24, name: "Saucony", rank: 24, image: "/images/sneakerBrands/saucony.png" },
  { id: 25, name: "UGG", rank: 25, image: "/images/sneakerBrands/ugg.png" },
];
